import useSEO from '../hooks/useSEO';

const AboutPage = () => {

  useSEO({
    title: 'Nosotros - J&D Propiedad Raíz',
    description: 'Conoce la historia, valores y propósito de J&D Propiedad Raíz. Somos una plataforma inmobiliaria 100% digital que transforma la manera de vivir e invertir en propiedades.',
    keywords: 'J&D Propiedad Raíz, inmobiliaria digital, historia, valores, innovación, transparencia, confianza',
    ogTitle: 'Nosotros - J&D Propiedad Raíz',
    ogDescription: 'Descubre cómo J&D Propiedad Raíz está revolucionando el mercado inmobiliario en Colombia con tecnología, transparencia y cercanía humana.',
    ogImage: 'https://jdpropiedadraiz.co/logo192.png',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Acerca de J&D Propiedad Raíz",
      "description": "Historia, valores y propósito de J&D Propiedad Raíz - Plataforma inmobiliaria digital en Colombia",
      "about": {
        "@type": "Organization",
        "name": "J&D Propiedad Raíz",
        "description": "Plataforma inmobiliaria 100% digital en Colombia"
      }
    }
  });

  return (
    <div className="min-h-screen bg-brand-black text-brand-white relative overflow-hidden">
        
        {/* Background with animated elements and watermarks */}
        <div className="fixed inset-0 pointer-events-none">
          {/* Animated gradient background */}
          {/*<div className="absolute inset-0 bg-gradient-to-br from-brand-black via-brand-black to-brand-gold/5 animate-pulse"></div>*/}
          
          {/* Floating logo watermarks */}
          <div className="absolute top-10 left-10 opacity-5 transform rotate-12 ">
            <img src="/logo192.png" alt="" className="w-32 h-32 filter brightness-0 invert" />
          </div>
          <div className="absolute top-1/3 right-20 opacity-3 transform -rotate-12 ">
            <img src="/logo192.png" alt="" className="w-24 h-24 filter brightness-0 invert" />
          </div>
          <div className="absolute bottom-2/4 left-1/6 opacity-4 transform rotate-45 " style={{animationDelay: '1s'}}>
            <img src="/logo192.png" alt="" className="w-20 h-20 filter brightness-0 invert" />
          </div>
          {/*<div className="absolute top-1/2 left-1/2 opacity-2 transform " style={{animationDelay: '2s'}}>
            <img src="/logo192.png" alt="" className="w-40 h-40 filter brightness-0 invert" />
          </div>
          <div className="absolute bottom-32 right-1/4 opacity-3 transform rotate-180 " style={{animationDelay: '1.5s'}}>
            <img src="/logo192.png" alt="" className="w-28 h-28 filter brightness-0 invert" />
          </div>*/}
          
          {/* Geometric animated shapes */}
          <div className="absolute top-1/4 left-1/3 w-2 h-32 bg-brand-gold/20 transform rotate-45 animate-pulse"></div>
          <div className="absolute bottom-1/3 right-1/3 w-2 h-24 bg-brand-gold/15 transform -rotate-45 "></div>
          <div className="absolute top-2/3 left-1/5 w-3 h-20 bg-brand-gold/10 transform rotate-12 animate-pulse" style={{animationDelay: '0.5s'}}></div>
          
          {/* Animated circles */}
          <div className="absolute top-1/5 right-1/5 w-4 h-4 bg-brand-gold/20 rounded-full animate-ping"></div>
          <div className="absolute bottom-1/5 left-1/3 w-3 h-3 bg-brand-gold/15 rounded-full animate-ping" style={{animationDelay: '1s'}}></div>
          <div className="absolute top-1/2 right-1/4 w-2 h-2 bg-brand-gold/25 rounded-full animate-ping" style={{animationDelay: '2s'}}></div>
        </div>

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 px-6 z-10">
          <div className="container mx-auto max-w-4xl text-center">
            <h1 
              data-animate="fade-up"
              className={`text-5xl md:text-6xl font-bold mb-6 text-brand-gold  `}
            >
              Nosotros
            </h1>
            <p 
              data-animate="fade-in"
              className={`text-xl md:text-2xl text-brand-gray leading-relaxed  `}
            >
              Transformando la manera en que las personas se relacionan con el mercado inmobiliario en Colombia
            </p>
          </div>
          
          {/* Decorative elements with enhanced animations */}
          <div className="absolute top-20 left-10 w-2 h-20 bg-brand-gold opacity-50 animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-2 h-20 bg-brand-gold opacity-50 "></div>
          <div className="absolute top-1/2 left-5 w-1 h-16 bg-brand-gold/60 transform rotate-45 animate-pulse" style={{animationDelay: '1s'}}></div>
        </section>

        {/* Historia Section */}
        <section className="py-20 px-6 relative z-10">
          <div className="container mx-auto max-w-5xl">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 
                  data-animate="fade-left"
                  className={`text-4xl font-bold mb-8 text-brand-gold  `}
                >
                  Historia
                </h2>
                <div className="space-y-6 text-brand-gray text-lg leading-relaxed">
                  <p 
                    data-animate="fade-up"
                    className={` `}
                  >
                    <span className="text-brand-gold font-semibold">J&D Propiedad Raíz</span> nació con una visión clara: transformar la manera en que las personas se relacionan con el mercado inmobiliario en Colombia.
                  </p>
                  <p 
                    data-animate="fade-up"
                    className={` `}
                    style={{animationDelay: '200ms'}}
                  >
                    Todo comenzó con la idea de romper las barreras de lo tradicional: largas visitas presenciales, trámites complejos y procesos lentos. En cambio, decidimos apostar por un modelo <span className="text-brand-gold font-semibold">100% digital y cercano</span>, donde la confianza, la transparencia y la tecnología fueran los pilares para conectar propietarios e inquilinos, compradores y vendedores.
                  </p>
                  <p 
                    data-animate="fade-up"
                    className={` `}
                    style={{animationDelay: '400ms'}}
                  >
                    Hoy, J&D no es solo una inmobiliaria, es una <span className="text-brand-gold font-semibold">plataforma online de soluciones inmobiliarias</span>, donde los clientes pueden:
                  </p>
                </div>
              </div>
              
              <div 
                data-animate="fade-right"
                className={`bg-brand-gold/10 p-8 rounded-lg border border-brand-gold/20 backdrop-blur-sm relative overflow-hidden `}
              >
                {/* Mini watermark inside the card */}
                <div className="absolute top-2 right-2 opacity-10">
                  <img src="/logo192.png" alt="" className="w-12 h-12 filter brightness-0 invert" />
                </div>
                <h3 
                  data-animate="fade-in"
                  className={`text-2xl font-semibold mb-6 text-brand-gold  `}
                >
                  Lo que ofrecemos:
                </h3>
                <ul className="space-y-4 text-brand-gray">
                  <li 
                    data-animate="fade-up"
                    className={`flex items-start  `}
                    style={{animationDelay: '600ms'}}
                  >
                    <span className="text-brand-gold mr-3 mt-1">•</span>
                    <span>Encontrar inmuebles de manera rápida y sencilla</span>
                  </li>
                  <li 
                    data-animate="fade-up"
                    className={`flex items-start  `}
                    style={{animationDelay: '800ms'}}
                  >
                    <span className="text-brand-gold mr-3 mt-1">•</span>
                    <span>Realizar procesos de arriendo o venta desde la comodidad de su celular o computador</span>
                  </li>
                  <li 
                    data-animate="fade-up"
                    className={`flex items-start  `}
                    style={{animationDelay: '1000ms'}}
                  >
                    <span className="text-brand-gold mr-3 mt-1">•</span>
                    <span>Confiar en un acompañamiento profesional, humano y seguro en cada etapa</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <div 
              data-animate="slide-up"
              className={`mt-12 text-center relative  `}
            >
              <div className="bg-gradient-to-r from-brand-gold/20 to-transparent p-8 rounded-lg backdrop-blur-sm relative overflow-hidden">
                {/* Background pattern */}
                <div className="absolute inset-0 opacity-5">
                  <div className="absolute top-4 left-4">
                    <img src="/logo192.png" alt="" className="w-8 h-8 filter brightness-0 invert" />
                  </div>
                  <div className="absolute bottom-4 right-4 transform rotate-180">
                    <img src="/logo192.png" alt="" className="w-8 h-8 filter brightness-0 invert" />
                  </div>
                </div>
                <p 
                  data-animate="fade-in"
                  className={`text-xl text-brand-white font-medium relative z-10  `}
                >
                  Nuestro propósito es claro: hacer que vivir o invertir en una propiedad sea una experiencia <span className="text-brand-gold">práctica, segura y emocionante</span>, sin importar dónde estés.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Valores Section */}
        <section className="py-20 px-6 bg-brand-black/50 relative z-10 backdrop-blur-sm">
          <div className="container mx-auto max-w-6xl">
            <div 
              data-animate="fade-up"
              className={`text-center mb-16  `}
            >
              <h2 className="text-4xl font-bold mb-6 text-brand-gold">
                Nuestros Valores
              </h2>
              <p className="text-xl text-brand-gray">
                Los principios que guían cada una de nuestras decisiones
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              
              {/* Valor 1 */}
              <div 
                data-animate="zoom-in"
                className={`bg-brand-gold/5 p-6 rounded-lg border border-brand-gold/20 hover:border-brand-gold/40 transition-all duration-300 group backdrop-blur-sm relative overflow-hidden hover:transform hover:scale-105  `}
                style={{animationDelay: '100ms'}}
              >
                {/* Card watermark */}
                <div className="absolute top-2 right-2 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                  <img src="/logo192.png" alt="" className="w-8 h-8 filter brightness-0 invert" />
                </div>
                <div className="h-16 w-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-gold/30 transition-all duration-300 group-hover:animate-pulse">
                  <span className="text-2xl">💡</span>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-brand-gold">
                  1. Innovación Digital
                </h3>
                <p className="text-brand-gray leading-relaxed">
                  Apostamos por la tecnología para simplificar procesos y dar experiencias rápidas y confiables.
                </p>
              </div>

              {/* Valor 2 */}
              <div 
                data-animate="zoom-in"
                className={`bg-brand-gold/5 p-6 rounded-lg border border-brand-gold/20 hover:border-brand-gold/40 transition-all duration-300 group backdrop-blur-sm relative overflow-hidden hover:transform hover:scale-105  `}
                style={{animationDelay: '200ms'}}
              >
                <div className="absolute top-2 right-2 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                  <img src="/logo192.png" alt="" className="w-8 h-8 filter brightness-0 invert" />
                </div>
                <div className="h-16 w-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-gold/30 transition-all duration-300 group-hover:animate-pulse">
                  <span className="text-2xl">🔍</span>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-brand-gold">
                  2. Transparencia
                </h3>
                <p className="text-brand-gray leading-relaxed">
                  Cada negocio se construye sobre la claridad y la honestidad, sin letras pequeñas.
                </p>
              </div>

              {/* Valor 3 */}
              <div 
                data-animate="zoom-in"
                className={`bg-brand-gold/5 p-6 rounded-lg border border-brand-gold/20 hover:border-brand-gold/40 transition-all duration-300 group backdrop-blur-sm relative overflow-hidden hover:transform hover:scale-105  `}
                style={{animationDelay: '300ms'}}
              >
                <div className="absolute top-2 right-2 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                  <img src="/logo192.png" alt="" className="w-8 h-8 filter brightness-0 invert" />
                </div>
                <div className="h-16 w-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-gold/30 transition-all duration-300 group-hover:animate-pulse">
                  <span className="text-2xl">🤝</span>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-brand-gold">
                  3. Cercanía Humana
                </h3>
                <p className="text-brand-gray leading-relaxed">
                  Aunque somos online, nuestra atención es cálida, personalizada y siempre disponible.
                </p>
              </div>

              {/* Valor 4 */}
              <div 
                data-animate="zoom-in"
                className={`bg-brand-gold/5 p-6 rounded-lg border border-brand-gold/20 hover:border-brand-gold/40 transition-all duration-300 group backdrop-blur-sm relative overflow-hidden hover:transform hover:scale-105  `}
                style={{animationDelay: '400ms'}}
              >
                <div className="absolute top-2 right-2 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                  <img src="/logo192.png" alt="" className="w-8 h-8 filter brightness-0 invert" />
                </div>
                <div className="h-16 w-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-gold/30 transition-all duration-300 group-hover:animate-pulse">
                  <span className="text-2xl">⚡</span>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-brand-gold">
                  4. Agilidad
                </h3>
                <p className="text-brand-gray leading-relaxed">
                  Procesos rápidos, respuestas inmediatas y soluciones prácticas al alcance de un clic.
                </p>
              </div>

              {/* Valor 5 */}
              <div 
                data-animate="zoom-in"
                className={`bg-brand-gold/5 p-6 rounded-lg border border-brand-gold/20 hover:border-brand-gold/40 transition-all duration-300 group backdrop-blur-sm relative overflow-hidden hover:transform hover:scale-105  `}
                style={{animationDelay: '500ms'}}
              >
                <div className="absolute top-2 right-2 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                  <img src="/logo192.png" alt="" className="w-8 h-8 filter brightness-0 invert" />
                </div>
                <div className="h-16 w-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-gold/30 transition-all duration-300 group-hover:animate-pulse">
                  <span className="text-2xl">🛡️</span>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-brand-gold">
                  5. Confianza
                </h3>
                <p className="text-brand-gray leading-relaxed">
                  Respaldamos cada transacción con contratos claros, asesoría legal y soporte constante.
                </p>
              </div>

              {/* Valor 6 */}
              <div 
                data-animate="zoom-in"
                className={`bg-brand-gold/5 p-6 rounded-lg border border-brand-gold/20 hover:border-brand-gold/40 transition-all duration-300 group backdrop-blur-sm relative overflow-hidden hover:transform hover:scale-105  `}
                style={{animationDelay: '600ms'}}
              >
                <div className="absolute top-2 right-2 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                  <img src="/logo192.png" alt="" className="w-8 h-8 filter brightness-0 invert" />
                </div>
                <div className="h-16 w-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-gold/30 transition-all duration-300 group-hover:animate-pulse">
                  <span className="text-2xl">🚀</span>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-brand-gold">
                  6. Visión de Futuro
                </h3>
                <p className="text-brand-gray leading-relaxed">
                  No solo administramos inmuebles, construimos relaciones duraderas y oportunidades de inversión.
                </p>
              </div>

            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-20 px-6 relative z-10">
          <div className="container mx-auto max-w-4xl text-center">
            <div 
              data-animate="slide-up"
              className={`bg-gradient-to-r from-brand-gold/10 to-brand-gold/5 p-12 rounded-2xl border border-brand-gold/20 backdrop-blur-sm relative overflow-hidden hover:transform hover:scale-[1.02] transition-all duration-300  `}
            >
              {/* CTA Background pattern */}
              <div className="absolute inset-0 opacity-3">
                <div className="absolute top-6 left-6 transform rotate-12">
                  <img src="/logo192.png" alt="" className="w-16 h-16 filter brightness-0 invert" />
                </div>
                <div className="absolute bottom-6 right-6 transform -rotate-12">
                  <img src="/logo192.png" alt="" className="w-16 h-16 filter brightness-0 invert" />
                </div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45">
                  <img src="/logo192.png" alt="" className="w-24 h-24 filter brightness-0 invert" />
                </div>
              </div>
              <h3 
                data-animate="fade-up"
                className={`text-3xl font-bold mb-6 text-brand-gold relative z-10  `}
              >
                ¿Listo para una nueva experiencia inmobiliaria?
              </h3>
              <p 
                data-animate="fade-in"
                className={`text-xl text-brand-gray mb-8 leading-relaxed relative z-10  `}
              >
                Únete a miles de personas que ya confían en J&D Propiedad Raíz para sus decisiones inmobiliarias más importantes.
              </p>
              <div 
                data-animate="fade-up"
                className={`flex flex-col sm:flex-row gap-4 justify-center relative z-10  `}
                style={{animationDelay: '400ms'}}
              >
                <a 
                  href="/inmuebles/arriendo/0-999999999999/" 
                  rel="noopener noreferrer"
                  className="bg-brand-gold text-brand-black px-8 py-4 rounded-lg font-semibold hover:bg-brand-gold/90 transition-all duration-300 transform hover:scale-105 inline-block text-center hover:shadow-lg hover:shadow-brand-gold/25"
                >
                  Explorar Propiedades
                </a>
                <a 
                  href="/contacto" 
                  rel="noopener noreferrer"
                  className="border-2 border-brand-gold text-brand-gold px-8 py-4 rounded-lg font-semibold hover:bg-brand-gold hover:text-brand-black transition-all duration-300 inline-block text-center hover:shadow-lg hover:shadow-brand-gold/25"
                >
                  Contactanos
                </a>
              </div>
            </div>
          </div>
        </section>

      </div>
    );
  };

  export default AboutPage;
